// extracted by mini-css-extract-plugin
export const bottomBar = "t_bg";
export const space = "t_bh";
export const btnUpdate = "t_w";
export const content = "t_R";
export const btnSkip = "t_bj";